/* Built In Imports */

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { useMediaQuery } from 'react-responsive';
/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import SimpleButton from '@components/Buttons/SimpleButton';

/**
 * Renders the ImageBannerAd Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.width
 * @param sectionContent.height
 * @param sectionContent.my
 * @param sectionContent.display
 * @param sectionContent.maxW
 * @returns {ReactElement} ImageBannerAd component
 */
const DownloadReport = ({ sectionContent, region, language }) => {
    const isMobile = useMediaQuery({ maxWidth: 960 });
    return (
        <Box 
        display={'grid'}
        pos={'relative'}
        h={{ base: '100%', md: 'auto' }}
        bgColor={{
        base: '#f8f5f0',
        lg: 'transparent',
      }}
    >
      <Box height={'auto'} w={'100%'}>
        <Box
          alignItems={'center'}
          display="flex"
          justifyContent="flex-end"
          h={{
            base: 'auto',
            sm: 'auto',
            xl: '500px',
          }}
          minH={{
            base: '340px',
            xl: '500px',
          }}
          backgroundRepeat="no-repeat"
          backgroundSize={{ base: 'cover', xl: 'cover' }}
          backgroundPosition={{ base: 'top', lg: 'bottom' }}
          backgroundImage={{
            base:
              sectionContent[0]?.mobileImage?.url ||
              sectionContent[0]?.image?.url,
            xl: sectionContent[0]?.image?.url,
          }}
          bgColor="#211637"
          mb={{ base: '0', xl: '0' }}
          pr={{ base: '0', xl: '50px' }}
        >
            {!isMobile && (
            <Flex
              flexDirection="column"
              verticalAlign={'center'}
              p={{ base: '7px', md: '0 0 0 5%' }}
              w={{ base: '100%', sm: '100%', md: '50%' }}
              maxW={{
                base: 'auto',
                md: '40%',
              }}
              display={{
                base: 'none',
                sm: 'none',
                lg: 'flex',
              }}
            >
                <Box
                  lineHeight={'1.25em'}
                  fontFamily={'FedraSansStd-book'}
                  fontSize={{ base: '24px', md: '28px' }}
                  color='#ffffff'
                  fontWeight={'700'}
                  mb="20px"
                  w={{base:'100%', md:'385px'}}
                >
                  {sectionContent[1]?.titleText}
                </Box>
                  <Box
                    fontSize={{
                      base: '16px',
                      md: '18px',
                    }}
                    lineHeight={{ base: '24px', md: '28px' }}
                    fontFamily="FedraSansStd-book"
                    color="#fff"
                    w={{base:'100%', md:'380px'}}
                  >
                    {StructuredTextContent(sectionContent[2].body)}
                  </Box>
                <Box marginTop="10px">
                 
                  <SimpleButton
                    style={sectionContent[3]}
                    mb="5px"
                  />
                </Box>
            </Flex>
          )}
        </Box>
        {isMobile && (
          <Flex
            display={{
              base: 'flex',
              sm: 'flex',
              md: 'flex',
              lg: 'none',
              xl: 'none',
            }}
            flexDirection="column"
            verticalAlign={'center'}
            w={{ base: '100%', sm: '80%', md: '96%', lg: '50%' }}
            p={{ base: '20px 15px', md: '30px' }}
            bgColor={'#1E1B17'}
          >
            <Box 
                fontSize={{ base: '24px', md: '28px' }}
                color='#ffffff'
                mb="20px"
            >
              {sectionContent[1]?.titleText}
            </Box>
            {sectionContent.titleSubtext && (
              <Box
                fontSize={{ base: '20px', md: '28px', lg: '30px' }}
                fontFamily="FedraSansStd-medium"
                color="#B95C23"
              >
                {StructuredTextContent(sectionContent.titleSubtext)}
              </Box>
            )}
                <Box
                  id="event-description"
                  fontSize={{ base: '16px', md: '18px' }}
                  fontFamily="FedraSansStd-book"
                  color="#ffffff"
                >
                  {StructuredTextContent(sectionContent[2].body)}
                </Box>
              <Box marginTop="18px" h="auto">
                <SimpleButton
                    style={sectionContent[3]}
                    mb="5px"
                  />
              </Box>
          </Flex>
        )}
        </Box>
        </Box>
    );
};

export default DownloadReport;
